import { render, staticRenderFns } from "./PlayerGames.vue?vue&type=template&id=d5f49b4c"
import script from "./PlayerGames.vue?vue&type=script&lang=js"
export * from "./PlayerGames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports